import React, { useEffect, useState } from 'react';
import './Carousel.css'; // Optional, for styling

const Carousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [finalImage, setFinalImage] = useState([]);

  // Function to go to the next image
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Function to go to the previous image
  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  useEffect(() => {
    const response = images.map((img) => {
      return img.image;
    })
    setFinalImage(response);
  },[images])
  return (
    <div className="carousel">
      <button className="carousel-btn prev" onClick={prevSlide}>
        &lt;
      </button>
      
      <img
        className="carousel-image"
        src={finalImage[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
      />
      <button className="carousel-btn next" onClick={nextSlide}>
        &gt;
      </button>
    </div>
  );
};

export default Carousel;
